export const TOGGLE_LOADING = "TOGGLE_LOADING";
export const SET_DRAW_SUMMARY = "SET_DRAW_SUMMARY";
export const SET_DRAW_VARIANTS = "SET_DRAW_VARIANTS";
export const ADD_NOTIFICATION = "ADD_NOTIFICATION";
export const SET_STATUS = "SET_STATUS";

export const initialState = {
  loading: true,
  hasError: false,
  notifications: false,
  content: {},
  drawDetails: {},
  variants: [],
};

export const toggleLoading = () => ({
  type: TOGGLE_LOADING,
});
export const setDrawSummary = (summary) => ({
  type: SET_DRAW_SUMMARY,
  summary,
});
export const setDrawVariants = (variants) => ({
  type: SET_DRAW_VARIANTS,
  variants,
});
export const setDrawStatus = (status) => ({
  type: SET_STATUS,
  status,
});
export const addNotification = (notificationDetails) => ({
  type: ADD_NOTIFICATION,
  notificationDetails,
});

// eslint-disable-next-line complexity
export const drawDetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_LOADING:
      return {
        ...state,
        loading: !state.loading,
      };
    case SET_DRAW_SUMMARY:
      return {
        ...state,
        drawDetails: { ...action.summary },
      };
    case SET_DRAW_VARIANTS:
      return {
        ...state,
        variants: action.variants.items.map(
          ({ sizeDescription, variantId }) => ({
            description: sizeDescription,
            value: variantId.toString(),
          })
        ),
      };
    case SET_STATUS:
      return {
        ...state,
        drawDetails: { ...state.drawDetails, status: action.status },
      };
    case ADD_NOTIFICATION:
      return {
        ...state,
        notifications: [action.notificationDetails],
      };
    default:
      return state;
  }
};
